import styled from 'styled-components';

import { Tooltip } from '@dreryk/react-components';

export const StyledVisitActionBarItemTooltip = styled(Tooltip)`
   width: 100%;
`;
StyledVisitActionBarItemTooltip.displayName = 'StyledVisitActionBarItemTooltip';
